import { useContext, useEffect } from "react";
import { UserContext } from "@shared/context/user";
import { useNavigate } from "react-router-dom";

const RequestVerificationEmail = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (user) {
      navigate("/asset/webinars");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.token]);

  useEffect(() => { }, []);
  return (
    <div className="flex justify-center items-center min-h-screen p-4 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
        <p>Please check your email.</p>
      </div>
    </div>
  );
};

export default RequestVerificationEmail;
